const trackScrollEvent = (top: number, id: string) => {
  const el = document.getElementById(id);
  const rect = el?.getBoundingClientRect();
  if (rect) {
    const topLimit = window.innerHeight / 2 - top;
    const bottomLimit = window.innerHeight / 2 - rect.height;
    const position = rect.top;

    return position > bottomLimit && position < topLimit;
  }
};

export default trackScrollEvent;
